import { render, staticRenderFns } from "./HandleGroupUser.vue?vue&type=template&id=a31d9870&scoped=true"
import script from "./HandleGroupUser.vue?vue&type=script&lang=js"
export * from "./HandleGroupUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31d9870",
  null
  
)

export default component.exports